const accountPending = {
  title: 'We’re finalizing your Advance',
  description: 'You can check back later to see the status.',
  button: 'Done',
};

export default accountPending;
